"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnowplowContextSchema = exports.SnowplowEventSchema = exports.SnowplowAction = exports.trackSnowplowEvent = void 0;
const browser_tracker_1 = require("@snowplow/browser-tracker");
const trackSnowplowEvent = (schema, data, eventContext) => {
    (0, browser_tracker_1.trackSelfDescribingEvent)({
        event: {
            schema,
            data,
        },
        context: eventContext ? [eventContext] : undefined,
    });
};
exports.trackSnowplowEvent = trackSnowplowEvent;
var SnowplowAction;
(function (SnowplowAction) {
    /** User completed survey */
    SnowplowAction["SurveyCompleted"] = "survey-completed";
    /** User closed survey without completing */
    SnowplowAction["SurveyDismissed"] = "survey-dismissed";
    /** User clicked on link to external survey */
    SnowplowAction["ExternalSurveyClick"] = "external-survey-click";
    /** User clicked on Give Feedback button in initial prompt */
    SnowplowAction["GiveFeedbackClick"] = "give-feedback-click";
    /** User clicked on Give Feedback button in footer */
    SnowplowAction["SurveyReopened"] = "survey-reopened";
})(SnowplowAction = exports.SnowplowAction || (exports.SnowplowAction = {}));
var SnowplowEventSchema;
(function (SnowplowEventSchema) {
    SnowplowEventSchema["QuestionSchema"] = "iglu:com.buoyhealth.user-feedback/survey-answers/jsonschema/1-0-0";
    SnowplowEventSchema["ActionSchema"] = "iglu:com.buoyhealth.user-feedback/survey-actions/jsonschema/1-0-0";
})(SnowplowEventSchema = exports.SnowplowEventSchema || (exports.SnowplowEventSchema = {}));
var SnowplowContextSchema;
(function (SnowplowContextSchema) {
    SnowplowContextSchema["CareResource"] = "iglu:com.buoyhealth/care-resource/jsonschema/1-0-0";
})(SnowplowContextSchema = exports.SnowplowContextSchema || (exports.SnowplowContextSchema = {}));
//# sourceMappingURL=snowplowConfig.js.map